// src/hooks/useHighlightFromQuery.js
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

// "원본 데이터 열기" 버튼 등으로 목록 페이지가 ?highlight={id} 쿼리와 함께 열렸을 때,
// 해당 id의 행을 찾아 (1) 기간 필터가 가려도 보이도록 넓히고 (2) 스크롤 + 하이라이트하고
// (3) onFound 콜백(예: 상세 모달 자동 오픈)을 실행한다.
export default function useHighlightFromQuery(rows, { setFromDate, setToDate, onFound } = {}) {
  const [searchParams] = useSearchParams();
  const highlightId = searchParams.get("highlight");
  const [highlightedId, setHighlightedId] = useState(null);
  const widenedRange = useRef(false);
  const triggered = useRef(false);

  // 대상 id가 현재 기간 필터에 걸려 목록에서 빠지지 않도록 범위를 넓힌다
  useEffect(() => {
    if (!highlightId || widenedRange.current) return;
    widenedRange.current = true;
    setFromDate?.("2000-01-01");
    setToDate?.("2099-12-31");
  }, [highlightId, setFromDate, setToDate]);

  // rows(필터 적용 후 목록)에서 대상을 찾으면 스크롤 + 하이라이트 + 콜백
  useEffect(() => {
    if (!highlightId || triggered.current || !rows?.length) return;
    const target = rows.find((r) => String(r.id) === String(highlightId));
    if (!target) return;
    triggered.current = true;
    setHighlightedId(target.id);
    requestAnimationFrame(() => {
      document.getElementById(`row-${target.id}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    onFound?.(target);
    // ✅ 하이라이트는 자동으로 사라지지 않는다 — 탭 전환 후 뒤늦게 확인해도 꺼져 있지 않도록
  }, [highlightId, rows, onFound]);

  // ✅ 호출부(각 목록 페이지)의 r.id와 타입이 다를 수 있어(문자열 vs 숫자) 비교는 항상 문자열로 통일
  const isHighlighted = (id) => highlightId != null && String(id) === String(highlightedId);

  return isHighlighted;
}
